import HttpService from './httpService';
import config from '../../config';

class FacturasApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async buscarListadoFacturas(params) {
    return this.get('buscarListadoFacturas', {
      params,
      responseType: params.excel ? 'blob' : 'json',
    });
  }

  async cargarClientes({ headquarter }) {
    return this.get('cargarClientes', { params: { headquarter } });
  }

  async cargarDatosFactura({ headquarter, id }) {
    return this.get('cargarDatosFactura', { params: { headquarter, id } });
  }

  async guardarDetallesFactura({ headquarter, formData, idFactura }) {
    return this.post('guardarDetallesFactura', { headquarter, formData, idFactura });
  }

  async editarDetallesFactura({ headquarter, formData, idFactura }) {
    return this.post('editarDetallesFactura', { headquarter, formData, idFactura });
  }

  async borrarDetallesFactura({ headquarter, idFactura }) {
    return this.post('borrarDetallesFactura', { headquarter, idFactura });
  }

  async borrarRelacionFactura({ headquarter, idFactura }) {
    return this.post('borrarRelacionFactura', { headquarter, idFactura });
  }

  async editarFacturacion({ headquarter, formData, idFactura }) {
    return this.post('editarFacturacion', { headquarter, formData, idFactura });
  }

  async crearAbono({ headquarter, importeAbono, nFactura }) {
    return this.post('crearAbono', { headquarter, importeAbono, nFactura });
  }

  async crearFacturaAbierta(payload) {
    return this.post('crearFacturaAbierta', payload);
  }

  async crearFacturaPDF({ headquarter, id, email, emailName }) {
    const reqConfig = {
      params: { headquarter: JSON.stringify({ headquarter, id, email, emailName }) },
    };

    if (email) {
      reqConfig.responseType = 'blob';
    }

    return this.get('crearFacturaPDF', reqConfig);
  }

  async filtrarContabilidad({ headquarter, tipoUsuario, fechaInicio, fechaFin, formaPago }) {
    return this.get('filtrarContabilidad', {
      params: { headquarter, tipoUsuario, fechaInicio, fechaFin, formaPago },
    });
  }

  async obtenerFacturasFiltradas({
    headquarter,
    ids,
    fechaFin,
    fechaInicio,
    tipoUsuario,
    formaPago,
  }) {
    return this.get('obtenerFacturasFiltradas', {
      params: { headquarter, ids, fechaFin, fechaInicio, tipoUsuario, formaPago },
    });
  }

  async controlarRecibos({
    headquarter,
    ids,
    formaPago,
    tipoUsuario,
    fechaFin,
    fechaInicio,
    opcion,
    fechaVTO,
  }) {
    return this.get('controlarRecibos', {
      params: {
        headquarter,
        ids,
        formaPago,
        tipoUsuario,
        fechaFin: fechaFin ? JSON.stringify(fechaFin) : undefined,
        fechaInicio: fechaInicio ? JSON.stringify(fechaInicio) : undefined,
        opcion,
        fechaVTO: JSON.stringify(fechaVTO),
      },
    });
  }
}

const facturasApiService = new FacturasApiService(config.REACT_APP_NODE_API);
export default facturasApiService;
